import React, { createContext, useContext, useState, useEffect } from 'react';

const ScannerSettingsContext = createContext();

export const ScannerSettingsProvider = ({ children }) => {
  // initialize from localStorage (default to "mobile")
  const [scannerType, setScannerType] = useState(
    () => localStorage.getItem('scannerType') || 'mobile'
  );

  // whenever it changes, persist to localStorage
  useEffect(() => {
    localStorage.setItem('scannerType', scannerType);
  }, [scannerType]);

  return (
    <ScannerSettingsContext.Provider value={{ scannerType, setScannerType }}>
      {children}
    </ScannerSettingsContext.Provider>
  );
};

// custom hook for easy access
export const useScannerSettings = () => {
  const ctx = useContext(ScannerSettingsContext);
  if (!ctx) throw new Error('useScannerSettings must be inside ScannerSettingsProvider');
  return ctx;
};
